import React from "react";
import { useTranslation } from 'react-i18next';

function FieldLabel({ display_name, name, is_required, classes }) {
    const { t } = useTranslation();

    return (
        <div className={`conf-field-name ${classes}`}>
            {display_name ? display_name : name}
            {
                is_required &&
                <span className='required-span'>({t('CONTENT.FLOW.REQUIRED')})</span>
            }
        </div>
    )

}

export default FieldLabel;